const prefix = '/dataShare/';

export default {
  _prefix: prefix,
  getStatFinanceLeaseExpenseDetail: prefix + 'datashare/query2/1627595756735111169/stat_finance_lease_expense_detail',
  getStatFinanceCalculateArea: prefix + 'datashare/query2/1627597356606234626/stat_finance_calculate_area',

}

